import type { SVGProps } from 'react'
import * as React from 'react'

const iconButtonrefreshAddressHover = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={48} height={48} rx={24} fill="#72DDB0" />
    <path
      d="M33 22C33 29 24 35 24 35C24 35 15 29 15 22C15 19.6131 15.9482 17.3239 17.636 15.636C19.3239 13.9482 21.6131 13 24 13C26.3869 13 28.6761 13.9482 30.364 15.636C32.0518 17.3239 33 19.6131 33 22Z"
      stroke="white"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 25C25.6569 25 27 23.6569 27 22C27 20.3431 25.6569 19 24 19C22.3431 19 21 20.3431 21 22C21 23.6569 22.3431 25 24 25Z"
      stroke="white"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x={27.5} y={23} width={12} height={12} rx={6} fill="#69E0AE" />
    <path d="M37.7804 31.0589L35.944 32.119L34.8838 30.2827" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M28.9951 27.1536L30.8314 26.0934L31.8916 27.9297" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M32.8054 25.978C33.3336 25.8799 33.8781 25.9173 34.388 26.0866C34.8979 26.256 35.3566 26.5517 35.7213 26.9462C36.086 27.3408 36.3448 27.8212 36.4736 28.3429C36.6023 28.8645 36.5969 29.4102 36.4577 29.9291L35.9432 32.1196M30.8316 26.0933L30.3171 28.2838C30.1779 28.8027 30.1724 29.3484 30.3012 29.8701C30.43 30.3917 30.6888 30.8722 31.0535 31.2667C31.4182 31.6612 31.8769 31.957 32.3868 32.1263C32.8967 32.2956 33.4412 32.333 33.9694 32.2349"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default iconButtonrefreshAddressHover
